import { render } from "./footer.vue?vue&type=template&id=4f7d6db4&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=4f7d6db4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4f7d6db4"

export default script